import {
  post_request,
  get_request_export
} from '../axiosFun'

//查询车辆监管列表
export const get_carMonitor_list = (params) => {
  params = {
    row: {
      vin: params.vin,
      carNumber: params.carNumber,
      carType: params.carType,
      drivingStatus: params.drivingStatus,
      faultStatus: params.faultStatus,
      area_id: params.groupId,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/carMonitor/list", params)
}
//获取所有车辆型号
export const get_all_car_type = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/carType/get_list", params)
};
//获取区域
export const get_all_select_area = (params) => {
  params = {
    row: {}
  }
  return post_request("/web/carMonitor/select_area", params)
};



// WEBPACK FOOTER //
// ./src/api/car_supervise/car_supervise.js